import { RARITY } from "./constants.js";

/**
 * Redemption codes → gift-forged LEGENDARY weapons. Hand a code to a player;
 * they enter it at the Shop and claim the weapon (once per save). These are
 * intentionally over-tuned "bad ass" gifts, not part of the drop economy.
 *
 * Each reward is `named: true` with NO `affinity`, so affinityFor() always
 * returns wield:true — any hero can wield it, no refusal, and it shows the ✦.
 */
const LEG = RARITY[RARITY.length - 1];   // Legendary tier

function legendary(spec) {
  return {
    kind: "weapon", named: true, codeReward: true,
    name: spec.name, model: spec.model, wtype: spec.wtype || "melee",
    range: spec.range || 2.9, cd: spec.cd || 0.5,
    glow: spec.glow || null,
    color: spec.color || LEG.color,
    rarity: LEG,
    dmgMin: spec.dmg[0], dmgMax: spec.dmg[1],
    element: spec.element || null, elementPower: spec.elementPower || 2.5,
    magic: !!spec.magic, aoe: spec.aoe || 0,
    lifesteal: spec.lifesteal || 0, critBonus: spec.critBonus || 0, moveBonus: spec.moveBonus || 0,
    special: spec.special || "", flavor: spec.flavor || "A gift-forged legendary relic.",
  };
}

// code (a UUID — unguessable, one per gift) → factory building a fresh weapon.
// Keys are lowercase; input is normalized to match. Add a row to hand out a new
// gift: generate a UUID and point it at a legendary weapon spec.
export const CODES = {
  "babb3667-1f7f-43cf-8efb-940f61436b68": () => legendary({
    name: "Sally", model: "legend/scythe", wtype: "melee", range: 3.1, cd: 0.55, magic: false, aoe: 0,
    dmg: [100000, 100000], element: "arcane", elementPower: 3, lifesteal: 1, critBonus: 1, color: "#f0c34b", glow: "#854cf0",
    special: "your mom", flavor: "A Patreon gift-forged legendary Legendary Scythe.",
  }),
  "7f3a9c21-4e8b-4d5a-9f2c-1b6e0a3d8c48": () => legendary({
    name: "Todd", model: "legend/axe_d", wtype: "melee", range: 2.9, cd: 0.55,
    dmg: [1000, 1000], element: "fire", elementPower: 3.4, lifesteal: 0.20, critBonus: 0.15, color: "#ff6a3d", glow: "#f0c34b",
    special: "Todd — asks no questions", flavor: "A gift-forged relic. Todd does not miss.",
  }),
  "2c9d6e15-8a4f-4b3c-b7e1-5d0f9a2c6b83": () => legendary({
    name: "Ashbringer", model: "legend/sword_g", wtype: "melee", range: 3.0, cd: 0.5,
    dmg: [560, 680], element: "fire", elementPower: 3.0, lifesteal: 0.15, critBonus: 0.12, color: "#ffb24a",
    special: "Ashbringer — cinders trail every swing", flavor: "A gift-forged legendary greatsword.",
  }),
  "e4b1a7f9-3c6d-42e8-8a5b-9f1c0d7e2a64": () => legendary({
    name: "Voidmaw", model: "legend/scythe", wtype: "melee", range: 3.1, cd: 0.55,
    dmg: [520, 640], element: "poison", elementPower: 3.0, lifesteal: 0.22, critBonus: 0.10, color: "#7bd645",
    special: "Voidmaw — drinks the fallen", flavor: "A gift-forged legendary scythe.",
  }),
};

/** Normalize player input (case-insensitive, trimmed) and resolve to a code. */
export function getCode(raw) {
  const key = String(raw || "").trim().toLowerCase();
  return CODES[key] ? { key, make: CODES[key] } : null;
}
